export const breakpoints: Record<string, number> = {
  xs: 320,
  sm: 576,
  md: 768,
  lg: 1024,
  xl: 1440,
};
